import { StatusFormatter } from '@components'

import { Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceDocumentType } from '../../../../enums/invoiceDocumentType'
import { QuoteStatus as QuoteStatusEnum } from '../../../../enums/quoteStatus'
import { quoteRowStatusToStatusFormatterVariant } from '../../constants/quoteRowStatusToStatusFormatterVariant'
import { quoteRowStatusToTitleKey } from '../../constants/quoteRowStatusToTitleKey'
import { getQuoteRowStatus } from '../../utils/getQuoteRowStatus'

interface QuoteStatusOptionProps {
  status: QuoteStatusEnum
}

export const QuoteStatusOption = ({ status }: QuoteStatusOptionProps): ReactElement => {
  const { t } = useTranslation()
  const rowStatus = getQuoteRowStatus(InvoiceDocumentType.Quote, status)

  return (
    <Flex alignItems="center" gap={Spacing.S8} justifyContent="flex-start" width="100%">
      <Flex alignItems="center" justifyContent="center" width={Spacing.S8}>
        <StatusFormatter variant={quoteRowStatusToStatusFormatterVariant[rowStatus]} />
      </Flex>
      <Text>{t(quoteRowStatusToTitleKey[rowStatus])}</Text>
    </Flex>
  )
}
